export default __webpack_public_path__ + "static/media/ocrgif.6baa63f1.gif";